
import React, { useEffect } from 'react';
import HeaderCandidat from '../header/headerCand';
import { useNavigate } from 'react-router-dom';

const DashboardCandidat = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) navigate('/');
  }, [navigate]);

  return (
    <div>
      <HeaderCandidat />
      <div style={{ padding: '2rem' }}>
        <h2>Bienvenue sur votre espace candidat</h2>
        <p>Vous pouvez consulter vos candidatures et gérer votre profil ici.</p>
      </div>
    </div>
  );
};

export default DashboardCandidat;
